(function () {
  function init(root) {
    if (!root || root.dataset.homeFaqInitialized === 'true') return;

    root.dataset.homeFaqInitialized = 'true';
    const items = Array.from(root.querySelectorAll('.home-faq-item'));

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        items.forEach((otherItem) => {
          if (otherItem !== item) otherItem.open = false;
        });
      });
    });
  }

  const currentScript = document.currentScript;
  const section = currentScript?.closest('.shopify-section');
  init(section?.querySelector('[data-home-faq]'));
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target?.querySelector?.('[data-home-faq]'));
  });
}());
